import React, { useState , useRef } from "react";
import "./Roof_waterproofing_bituminous_sheets.css";
import { Link } from "react-router-dom";
import ContactSection2 from '../Category/ContactSection2';
import Adsense from "../Adsense";       // 🔥 ייבוא באנר דף הבית (או באנר כללי)
import InArticleAd from "../InArticleAd"; // 🔥 ייבוא המודעה החדשה לגוף המאמר

export default function Sealing_underground_structures() {


  return (

    <div className="Roof_waterproofing_bituminous_sheets-page">
      <div className="Roof_waterproofing_bituminous_sheets-hero">
        <div className="Roof_waterproofing_bituminous_sheets-overlay">
          <h1>     איטום מבנים תת – קרקעיים</h1>
        </div>
<div>
</div>
</div>
    <div className="page6">
 <div className="breadcrumb6">
  <Link to="/">בית</Link> /{" "}
  <Link to="/OurServices"> השירותים שלנו </Link>/{" "}
   <Link to="/Sealing_underground_structures">     איטום מבנים תת – קרקעיים</Link>{" "}
</div>
    </div>


      {/* CONTENT */}
<div className="page6">
  <div className="container">
            <div className="red-banner">
איטום מבנים תת–קרקעיים ומקומות ללא גישה חיצונית


</div>
    <div className="content-row2">



      <div className="text-box">


  <h2 className="info-title">  איטום מבנים תת–קרקעיים ומקומות ללא גישה חיצונית (כגון מרתפים) ע"י הזרקת חומרים פוליאורתנים ואפוקסים מיוחדים לאטימת המבנה מבפנים:





</h2>
<p>

איטום בהזרקות שידוע בשמו איטום שלילי הוא האיטום היחיד שנעשה מחלקו הפנימי של המבנה ולא מבחוץ את החדרת החומר מבצעים ע"י הזרקה מיוחדת לתוך פטמות הזרקה מיוחדות שמקבעים בקיר לפני כן חומר ההזרקה הוא בעל כושר התנפחות גבוהה ואפשר ואפילו רצוי לבצע את ההזרקה בזמן שהמקום רטוב.




</p>


      </div>

    </div>





    <ContactSection2/>
<div className="links2">


  <Link to="/Waterproofing_roofs_with_PVC_sheets" className="link-right" >     איטום גגות ע"י יריעות P.V.C
</Link>
  <Link to="/Roof_sealing_with_pure_polyurethane_spraying" className="link-left" >   איטום גגות בהתזת פוליאוריטן טהור  </Link>


</div>

      </div>
    </div>
  

      </div>
  );
}


